interface PrismContainer extends HTMLElement {
  __prismIO?: IntersectionObserver;
}

interface StartPrismVisibilityInput {
  container: HTMLDivElement;
  suspendWhenOffscreen: boolean;
  startRAF: () => void;
  stopRAF: () => void;
}

interface StopPrismVisibilityInput {
  container: HTMLDivElement;
  suspendWhenOffscreen: boolean;
}

export interface ShouldPausePrismInput {
  documentHidden: boolean;
  externallyPaused: boolean;
}

/**
 * Coverage is not intersection: an opaque overlay still intersects the viewport, so
 * IntersectionObserver never suspends a covered Prism. The owner tells us instead.
 */
export function shouldPausePrism({ documentHidden, externallyPaused }: ShouldPausePrismInput): boolean {
  return documentHidden || externallyPaused;
}

export function startPrismVisibility({
  container,
  suspendWhenOffscreen,
  startRAF,
  stopRAF,
}: StartPrismVisibilityInput): void {
  if (!suspendWhenOffscreen) {
    startRAF();
    return;
  }

  const intersectionObserver = new IntersectionObserver(entries => {
    const visible = entries.some(entry => entry.isIntersecting);
    if (visible) startRAF();
    else stopRAF();
  });
  intersectionObserver.observe(container);
  startRAF();
  (container as PrismContainer).__prismIO = intersectionObserver;
}

export function stopPrismVisibility({ container, suspendWhenOffscreen }: StopPrismVisibilityInput): void {
  if (!suspendWhenOffscreen) return;

  const intersectionObserver = (container as PrismContainer).__prismIO;
  if (intersectionObserver) intersectionObserver.disconnect();
  delete (container as PrismContainer).__prismIO;
}
